import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpStatusCodeEnum } from '@client-monorepo/common/network';
import { SnackbarService } from '@digipay/ngx-snackbar';
import { Router } from '@angular/router';
import { AuthenticationStorageService } from '../../components/core/services/authentication-storage.service';
import { MaknaAuthenticationService } from '../../features/makna-authentication/services/makna-authentication.service';
import { EnterPasswordService } from '../../shared/components/enter-password/enter-password.service';
import { AuthService } from '../../components/core/services/auth.service';
import { WEALTH_INTERCEPTOR_TOKEN_NOTIFIER } from '../../components/core/interceptors/interceptor-share.token';
import { NavigationConfig } from '@client-monorepo/wealth/navigation';

export const LOGIN_URL = 'users/login';

@Injectable({
  providedIn: 'root',
})
export class PinInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private enterPasswordService: EnterPasswordService,
    private authenticationStorageService: AuthenticationStorageService,
    private maknaAuthenticationService: MaknaAuthenticationService,
    @Inject(WEALTH_INTERCEPTOR_TOKEN_NOTIFIER)
    public tokenNotifier: BehaviorSubject<string>,
    private router: Router,
    @Inject('APP_CONFIG') private config: NavigationConfig,
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.config.appName === 'wealth' || this.router.url.startsWith('/mini-app/wealth')) {
      return next.handle(request).pipe(
        catchError((error) => {
          // if (request.url.includes('users/tac')) return of(error);
          if (this.needGetPassword(error)) {
            return this.handle403Error(request, next);
          }
          if (this.needLogout(error)) {
            this.authService.purgeAuth(true);
          }
          return throwError(() => error);
        }),
      );
    }
    return next.handle(request);
  }

  handle403Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userId = this.authenticationStorageService.getUserId();
    // @ts-ignore
    return this.enterPasswordService
      .getUserPassword(userId, [100])
      .onLogin()
      .pipe(
        catchError((err) => {
          return throwError(() => err);
        }),
      )
      .subscribe((loginResponse: any) => {
        if (loginResponse?.accessToken) {
          this.enterPasswordService.login.complete();
          this.enterPasswordService.hideGetPasswordWindow().clearData();
          this.authenticationStorageService.updateAuth(loginResponse);
          this.maknaAuthenticationService.refresh().subscribe((res) => {
            return this.tokenNotifier.next(loginResponse.accessToken);
          });
        }
      });
  }

  private needGetPassword(error: HttpErrorResponse): boolean {
    return Boolean(
      error instanceof HttpErrorResponse &&
        error.status === HttpStatusCodeEnum.Forbidden &&
        [2002, 2007].indexOf(error?.error?.result?.status) >= 0,
    );
  }

  private needLogout(error: HttpErrorResponse): boolean {
    return Boolean(
      error instanceof HttpErrorResponse &&
        error.status === HttpStatusCodeEnum.Forbidden &&
        [2002, 2007].indexOf(error.error.result.status) === -1,
    );
  }
}
